import { z } from 'zod';
import { AwsIamRoleArnRegex } from './aws-patterns.constants';

export const AwsIamRoleArnSchema = z
  .string()
  .trim()
  .regex(AwsIamRoleArnRegex, {
    error: 'IAM role ARN must match arn:aws:iam::123456789012:role/RoleName',
  });

export const OptionalAwsIamRoleArnSchema = z
  .union([AwsIamRoleArnSchema, z.literal('')])
  .nullable()
  .optional();
